import React, { useMemo } from 'react';
import { generateHeaders } from './tableHeaders';
import Dashboard from '../../../../common/rooms/details/Monitor/Dashboard';
import RoomCode from '../../../../common/RoomCode';
import StudentRosterRow from '../../../students/roster/StudentRosterRow';
import AccordionSummary from '../../../../common/AccordionSummary';
import { useStateValue } from '../../../../../../context/AppContext';
import { Icon } from '@cb/apricot-react';
import TestDayExamTimings from '../../../../common/examTimings/TestDayExamTimings';
import { useMonitorTimingSummary } from '../../../../../../hooks/useMonitorTimingSummary';
import { Room } from '../../../../../../types/Rooms';
import { shouldShowSection3 } from '../../../../../../utils/section3';

interface MonitorStudentsProps {
  toggleDirections: React.ReactNode;
  room: Room;
  refetch?: () => void;
}

export default function MonitorStudents({ toggleDirections, room, refetch = () => {} }: MonitorStudentsProps) {
  const { orgEvent } = useStateValue();
  const isSummaryLoading = !Array.isArray(room?.students);
  const students = useMemo(() => (Array.isArray(room?.students) ? room.students : []), [room]);
  const timingTitle = `${orgEvent?.eventTitle || 'Event'} Timings`;
  const { startSummaryText, endSummaryText } = useMonitorTimingSummary({ students });
  const assessmentId = orgEvent?.asmtId;
  const tdtkAsmtType = orgEvent?.tdtkAsmtType;

  const shouldShowSection3Summary = useMemo(() => {
    return shouldShowSection3(students);
  }, [students]);

  return (
    <>
      <div className='wizard-heading-container row'>
        <div
          aria-level={1}
          className='wizard-heading col-xs-12 col-md-7'
          data-automation='wizard-main-heading'
          id='wizard-main-heading'
          role='heading'
          tabIndex={-1}
        >
          Monitoring Dashboard
        </div>
        <div className='wizard-right-panel col-xs-12 col-md-5'>
          <div className='wizard-room-code-container ml-auto text-right'>
            <div className='wizard-room-code-title' data-automation='wizard-room-start-code'>
              Start Code:
            </div>
            <div className='wizard-room-code'>
              <RoomCode code={room?.startPin} />
            </div>
          </div>
        </div>
      </div>
      <div className='mt-3'>{toggleDirections}</div>
      <div className='box-card py-3 px-3 mt-3'>
        <AccordionSummary
          title={
            <span className='tdtk-summary-accordion__title-content'>
              <Icon name='pending' decorative className='tdtk-summary-accordion__title-icon' />
              <span>{timingTitle}</span>
            </span>
          }
          summaryLoading={isSummaryLoading}
          startSummaryText={startSummaryText}
          endSummaryText={endSummaryText}
          panelContent={
            <TestDayExamTimings
              assessmentId={assessmentId}
              tdtkAsmtType={tdtkAsmtType}
              shouldShowSection3={shouldShowSection3Summary}
            />
          }
        />
      </div>
      <div className='dashboard-wrapper mt-3'>
        <Dashboard
          generateHeaders={generateHeaders}
          room={room}
          refetch={refetch}
          StudentRosterRow={StudentRosterRow}
          shouldShowSection3={shouldShowSection3Summary}
        />
      </div>
    </>
  );
}
